import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalFooterComponent } from '@shared/components/modal-footer/modal-footer.component';
import { TranslatePipe } from '@core/pipes';
import { AsyncPipe } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SvgComponent } from '@shared/components/svg/svg.component';
import { Substitutions } from '@selfcare/cms';

@Component({
  selector: 'sc-simcard-swap-esim-modal',
  imports: [
    ModalComponent,
    ButtonComponent,
    ModalFooterComponent,
    SvgComponent,
    TranslatePipe,
    AsyncPipe,
  ],
  templateUrl: './simcard-swap-esim-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimcardSwapEsimModalComponent {
  public readonly Substitutions = Substitutions;

  constructor(private readonly dialogRef: DialogRef<boolean>) {}

  public close(approved: boolean = false) {
    this.dialogRef.close(approved);
  }
}
